import { AlertColor } from "@mui/material";
import { useAppDispatch } from "../app/hooks";
import {
  Message,
  MessageOptions,
  messageActions,
} from "../features/message/messageSlice";
import { translate } from "../features/messaging/helpers";

const useMessage = () => {
  const initialState: Message = {
    text: "",
    type: "info",
  };

  const { setMessage, unsetMessage } = messageActions;
  const dispatch = useAppDispatch();

  const sendMessage = (
    text: string,
    type: AlertColor | undefined = "info",
    options?: MessageOptions,
  ) => {
    dispatch(
      setMessage({
        text: translate(text),
        type: type,
        options,
      }),
    );

    if (type !== "error") {
      setTimeout(() => {
        dispatch(setMessage(initialState));
      }, options?.timeOut || 6000);
    }
  };

  const wipeMessage = () => {
    dispatch(unsetMessage());
  };

  return {
    sendMessage,
    wipeMessage,
  };
};

export default useMessage;
